import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-system-privacy-modal',
  templateUrl: './system-privacy-modal.component.html',
  styleUrls: ['./system-privacy-modal.component.scss']
})
export class SystemPrivacyModalComponent implements OnInit {
  privacyHeader: any;
  privacyMessage: any;
  firstLogin: boolean;

  constructor(private dialogRef: MatDialogRef<SystemPrivacyModalComponent>) {}

  ngOnInit() {
    this.firstLogin = false;
    this.privacyHeader = 'PRIVACY AND USAGE POLICY';
  }

  accept() {
    this.dialogRef.close({ status: confirm, data: true });
  }

  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: false });
  }
}
